<header role="banner">
  <div class="topbar">
    <nav class="nav-main-mobile" id="nav-main-mobile" role="navigation" vocab="http://schema.org/" typeof="SiteNavigationElement">
      <label class="nav-trigger" for="nav-main-mobile__check">
        <span class="nav-trigger__burger"><span class="nav-trigger__burger-inner"></span></span>
      </label>
      <input type="radio" class="nav-main-mobile__check" id="nav-main-mobile__check" name="nav-main-mobile__check" />
      <input type="radio" class="nav-main-mobile__check nav-main-mobile__check--uncheck" id="nav-main-mobile__uncheck" name="nav-main-mobile__check" />
      <div class="nav-main-mobile__offcanvas">
        <label for="nav-main-mobile__uncheck" id="nav-main-mobile__close-offcanvas" class="nav-main-mobile__close-offcanvas">{{'buttons.closeMenu' | translate}}</label>
        <div class="nav-main-mobile__link-list">
         <!--Navigation Menu: Begin -->
            <nav class="nav-main-mobile--header">
              <div *ngIf="menus$">
                <ul class="link-list">
                  <ng-container *ngTemplateOutlet="recursiveMenuMobile; context:{ list: menus$}"></ng-container>
                </ul>
              </div>
            </nav>
            <!-- Navigation Menu: End -->
            <div class="topbar__profile-menu">
              <app-profile-menu></app-profile-menu>
            </div>
        </div>
      </div>
    </nav>

    <div class="grid-container grid-container--site-width">
      <div class="grid-column">
        <div class="topbar__inner">
          <div class="topbar__logo">
            <a href="/">
              <img class="logo" src="/assets/images/logo.png">
            </a>
            
            <app-non-productive-environment></app-non-productive-environment>         
          </div>

          <div class="topbar__profile-menu">
            <app-profile-menu></app-profile-menu>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="navigation-menu">
    <div class="list-group list-group--horizontal">
      <div class="list-group__item">
        <div class="nav-main">
          <div *ngIf="menus$">
            <ul class="nav-main-list">
              <ng-container *ngTemplateOutlet="recursiveMenu; context:{ list: menus$, isSubMenu: false}"></ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<ng-template #recursiveMenuMobile let-list="list">
  <li *ngFor="let item of list" class="link-list__item" routerLinkActive="nav-main-list__item--active">
    <a [href]="item.path" class="link" *ngIf="item.menus.length == 0" routerLinkActive="nav-main-list__item--active" title='{{ item.name | translate}}'
      [ngClass]="{'nav-main-list__item--active': isActiveNavItemByPath(item.path)}"
      (click)="onOpcionClick($event)">{{ item.name | translate }}</a>
    <span class="link has-submenu" *ngIf="item.menus.length > 0" title='{{ item.name | translate}}'
      [ngClass]="{'nav-main-list__item--active': isActiveNavItemByPath(item.path)}"
      (click)="onOpcionClick($event)">{{ item.name | translate }}</span>
    <ul class="link-list" *ngIf="item.menus.length > 0">
      <ng-container *ngTemplateOutlet="recursiveMenuMobile; context:{ list: item.menus }"></ng-container>
    </ul>
  </li>
</ng-template>

<ng-template #recursiveMenu let-list="list">
  <li *ngFor="let item of list" class="nav-main-list__item" routerLinkActive="nav-main-list__item--active">
    <button mat-button [matMenuTriggerFor]="menu.childMenu" [title]="item.name | translate" [ngClass]="{'nav-main-list__item--active': isActiveNavItemByPath(item.path)}" >{{item.name | translate}}</button>
    <app-menu-item  #menu [items]="item.menus"></app-menu-item>
  </li>
</ng-template>

